<template>
  <div class="card" v-if="nuevoProducto">
    <!-- <CrudProveedor></CrudProveedor> -->
  </div>
  <ProductoCreate
    :mostrar="mostrarProductoModal"
    :producto="producto"
    @closeModal="cerrarModal"
    @actualizarListadoProductos="obtenerListadoProductos"
  ></ProductoCreate>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Par&aacute;metros</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Productos</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <router-link to="/productos" class="text-900 line-height-3"
        >Listado de Productos</router-link
      >
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Productos
          <Badge size="xlarge" severity="success"> {{ totalRecords }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          label="Nuevo"
          v-if="'Producto Crear' in auth.user.permissions"
          class="p-button-outlined mr-2 p-button-lg"
          icon="pi pi-plus"
          v-tooltip.top="'Registrar Nuevo Producto'"
          @click="openModal"
          :disabled="!cargando ? false : true"
        ></Button>
      </div>
    </div>
    <div class="mt-4">
      <!--
        [2026-10] CAMBIO: EDICIÓN DE CELDA REACTIVADA 2026-10-27 (antes: «2026-10: EDICIÓN DE CELDA DESACTIVADA»).
        MOTIVO: el cliente necesita cambiar precios rápido desde la lista. Ahora solo P.VENTA, Yango, Pedido Ya y Turbo se
        editan (clic, escribir, Enter) y se guardan al instante en TODAS las sucursales activas, con aviso y botón «Deshacer».
        P.COMPRA, S.ACTUAL, estado y demás siguen sin editarse. Historial: la edición se había desactivado porque los
        usuarios editaban un precio sin querer al hacer clic en la tabla; ahora el cambio queda a la vista y se deshace.
        NO CAMBIAR: el DataTable no muta la fila al editar (el editor trabaja sobre una copia: BodyCell.vue de PrimeVue
        3.53.1, editingRowData); la fila solo cambia tras el éxito del servidor.
        REF: docs_trabajo/resultado_celda_frontend.md
        Nota anterior (conservada):
                2026-10: EDICIÓN DE CELDA DESACTIVADA (decisión del negocio, temporal).
        QUÉ: se quitaron de este DataTable `editMode="cell"` y `@cell-edit-complete="onCellEditComplete"`, y las
        plantillas #editor de P.COMPRA, P.VENTA, Yango, Pedido Ya y Turbo (quedan comentadas más abajo).
        POR QUÉ: los usuarios editaban un precio sin querer al hacer clic en la tabla. Por ahora los precios se
        cambian en la recepción de la Orden de Compra (ComprasRecibir.vue, por sucursal y canal); más adelante se
        buscará otro lugar para editarlos.
        NO CAMBIAR: el backend ni el endpoint (POST producto/{id}/update-cell, ProductoController@updateCell) siguen
        intactos; el método onCellEditComplete y ProductService.updateCell se conservan sin uso. Ordenar, filtrar y
        paginar (lazy) no dependen de esto.
        PARA REACTIVARLA: volver a poner en el DataTable
            editMode="cell"
            @cell-edit-complete="onCellEditComplete"
        y descomentar los cinco bloques #editor.
      -->
      <DataTable
        ref="dtlaboratorios"
        dataKey="id"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[20, 100, 500, 1000]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Productos"
        responsiveLayout="scroll"
        stripedRows
        showGridlines
        filterDisplay="menu"
        :value="productos"
        :loading="cargando"
        :paginator="true"
        :filters="buscar"
        :rows="20"
        :rowHover="true"
        :lazy="true"
        :totalRecords="totalRecords"
        v-model:filters="buscar"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        selectionMode="single click"
        editMode="cell"
        @cell-edit-complete="onCellEditComplete"
        @cell-edit-cancel="onCellEditCancel"
        :pt="{
            column: {
                bodycell: ({ state }) => ({
                    class: [{ 'pt-0 pb-0': state && state['d_editing'] }]
                })
            }
        }"
      >
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid"
            >No existen Registros!</span
          ></template
        >
        <Column
          field="codigo_interno"
          header="CÓD.INT."
          filterMatchMode="startsWith"
          :showFilterMatchModes="false"
          style="width: 30px"
          :class="'text-right'"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="CÓD..."
            />
          </template>
        </Column>
        <Column
          field="descripcion"
          header="DESCRIPCIÓN/DETALLE"
          style="width: 300px; font-weight: bold"
          filterMatchMode="startsWith"
          :showFilterMatchModes="false"
        >
          {{ data.descripcion }}
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="DESCRIPCIÓN/DETALLE"
            />
          </template>
        </Column>
        <Column
          v-if="false"
          field="grupo.nombre"
          header="GRUPO"
          filterMatchMode="startsWith"
          :showFilterMatchModes="false"
          style="width: 90px"
        >
          {{ data.grupo.nombre }}
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="GRUPO"
            />
          </template>
        </Column>
        <Column
          field="imagen"
          header="IMAGEN"
          v-if="'Producto VerImagen' in auth.user.permissions"
        >
          <template #body="{ data }">
            <template v-if="data.imagen != null">
              <Image
                :src="getImageUrl(data.imagen)"
                width="30"
                preview
              ></Image>
            </template>
            <template v-else><p>---</p></template>
          </template>
        </Column>
        <Column
          field="fabricas.nombre"
          header="MARCA"
          filterMatchMode="startsWith"
          :showFilterMatchModes="false"
          v-if="false"
        >
          {{ data.fabricas.nombre }}
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="MARCA"
            />
          </template>
        </Column>
        <Column field="unidad_medida_nombre" header="U.MEDIDA" v-if="false">
          {{ data.unidad_medida_nombre }}
        </Column>
        <Column class="text-center" field="stock_actual" header="S.ACTUAL">
          <template #body="{ data }">
            <div v-if="data.tipo_catalogo == 1" :class="claseEstado2(data)">
              {{ sinDecimal(data.stock_actual) }}
            </div>
            <div v-else-if="data.tipo_catalogo == 2">SERVICIO</div>
            <div v-else-if="data.tipo_catalogo == 3">INSUMO</div>
          </template>
        </Column>
        <Column field="precio_compra" header="P.COMPRA" class="text-right">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.precio_compra) }}
          </template>
          <!-- [2026-10] DEPRECADO/SIN USO 2026-10: se cambia en la recepción de compra (ComprasRecibir.vue). MOTIVO: la lista
               solo edita precios de venta. REF: docs_trabajo/resultado_celda_frontend.md
          <template #editor="{ data, field }">
            <InputText v-model="data[field]" autofocus />
          </template>
          -->
        </Column>
        <Column
          v-if="mostrar_precio_cif"
          field="precio_cif"
          header="P.CIF"
          class="text-right"
        >
          {{ convertirNumeroGermanicFormat(data.precio_cif ?? "-") }}
        </Column>
        <Column
          field="precio_sugerido"
          header="P.VENTA"
          class="text-right font-bold font-medium"
        >
          <template #body="{ data }">
            <i v-if="guardandoCeldas[data.id + ':precio_sugerido']" class="pi pi-spin pi-spinner mr-1"></i>
            <span v-if="data.precio_venta > 0">
              {{ convertirNumeroGermanicFormat(data.precio_venta) }}
            </span>
            <span v-else>
              {{ convertirNumeroGermanicFormat(data.precio_sugerido) }}
            </span>
          </template>
          <!-- [2026-10] CAMBIO: editor de precio por celda (se guarda en todas las sucursales activas). MOTIVO: cambio rápido
               de precios desde la lista. REF: docs_trabajo/resultado_celda_frontend.md -->
          <template #editor="{ data, field }">
            <InputNumber
              :modelValue="valorEditor(data, field)"
              @update:modelValue="(v) => editarCelda(data, field, v)"
              @focus="$event.target && $event.target.select && $event.target.select()"
              :disabled="!!guardandoCeldas[data.id + ':' + field]"
              mode="decimal"
              :min="0"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :useGrouping="false"
              inputClass="w-full text-right"
              autofocus
            />
          </template>
        </Column>
        <Column field="pv2" header="Yango" class="text-right">
          <template #body="{ data }">
            <i v-if="guardandoCeldas[data.id + ':pv2']" class="pi pi-spin pi-spinner mr-1"></i>
            {{ convertirNumeroGermanicFormat(data.pv2 ?? "") }}
          </template>
          <!-- [2026-10] CAMBIO: editor de precio por celda (se guarda en todas las sucursales activas). MOTIVO: cambio rápido
               de precios desde la lista. REF: docs_trabajo/resultado_celda_frontend.md -->
          <template #editor="{ data, field }">
            <InputNumber
              :modelValue="valorEditor(data, field)"
              @update:modelValue="(v) => editarCelda(data, field, v)"
              @focus="$event.target && $event.target.select && $event.target.select()"
              :disabled="!!guardandoCeldas[data.id + ':' + field]"
              mode="decimal"
              :min="0"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :useGrouping="false"
              inputClass="w-full text-right"
              autofocus
            />
          </template>
        </Column>
        <Column field="pv3" header="Pedido Ya" class="text-right">
          <template #body="{ data }">
            <i v-if="guardandoCeldas[data.id + ':pv3']" class="pi pi-spin pi-spinner mr-1"></i>
            {{ convertirNumeroGermanicFormat(data.pv3 ?? "") }}
          </template>
          <!-- [2026-10] CAMBIO: editor de precio por celda (se guarda en todas las sucursales activas). MOTIVO: cambio rápido
               de precios desde la lista. REF: docs_trabajo/resultado_celda_frontend.md -->
          <template #editor="{ data, field }">
            <InputNumber
              :modelValue="valorEditor(data, field)"
              @update:modelValue="(v) => editarCelda(data, field, v)"
              @focus="$event.target && $event.target.select && $event.target.select()"
              :disabled="!!guardandoCeldas[data.id + ':' + field]"
              mode="decimal"
              :min="0"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :useGrouping="false"
              inputClass="w-full text-right"
              autofocus
            />
          </template>
        </Column>
        <Column field="pv4" header="Turbo" class="text-right">
          <template #body="{ data }">
            <i v-if="guardandoCeldas[data.id + ':pv4']" class="pi pi-spin pi-spinner mr-1"></i>
            {{ convertirNumeroGermanicFormat(data.pv4 ?? "") }}
          </template>
          <!-- [2026-10] CAMBIO: editor de precio por celda (se guarda en todas las sucursales activas). MOTIVO: cambio rápido
               de precios desde la lista. REF: docs_trabajo/resultado_celda_frontend.md -->
          <template #editor="{ data, field }">
            <InputNumber
              :modelValue="valorEditor(data, field)"
              @update:modelValue="(v) => editarCelda(data, field, v)"
              @focus="$event.target && $event.target.select && $event.target.select()"
              :disabled="!!guardandoCeldas[data.id + ':' + field]"
              mode="decimal"
              :min="0"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :useGrouping="false"
              inputClass="w-full text-right"
              autofocus
            />
          </template>
        </Column>
        <Column field="pv5" header="Cortesía" class="text-right">
          <template #body="{ data }">
            <i v-if="guardandoCeldas[data.id + ':pv5']" class="pi pi-spin pi-spinner mr-1"></i>
            {{ convertirNumeroGermanicFormat(data.pv5 ?? "") }}
          </template>
          <!-- [2026-10] CAMBIO: editor de precio por celda (se guarda en todas las sucursales activas). MOTIVO: cambio rápido
               de precios desde la lista. REF: docs_trabajo/resultado_celda_frontend.md -->
          <template #editor="{ data, field }">
            <InputNumber
              :modelValue="valorEditor(data, field)"
              @update:modelValue="(v) => editarCelda(data, field, v)"
              @focus="$event.target && $event.target.select && $event.target.select()"
              :disabled="!!guardandoCeldas[data.id + ':' + field]"
              mode="decimal"
              :min="0"
              :minFractionDigits="2"
              :maxFractionDigits="2"
              :useGrouping="false"
              inputClass="w-full text-right"
              autofocus
            />
          </template>
        </Column>
        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado[data.estado.value]">
              {{ data.estado.label }}
            </span>
          </template>
        </Column>
        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              v-tooltip.top="'Ver Acciones'"
              icon="pi pi-ellipsis-v"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
      </DataTable>
    </div>
    <!-- [2026-10] CAMBIO: toast propio de la edición de precio (grupo «precio-celda») con botón «Deshacer». MOTIVO: un solo aviso
         por guardado y por fallo, y poder revertir un precio cambiado sin querer. REF: docs_trabajo/resultado_celda_frontend.md -->
    <Toast group="precio-celda" position="top-right">
      <template #message="slotProps">
        <div class="flex flex-column w-full">
          <span class="font-bold">{{ slotProps.message.summary }}</span>
          <span data-testid="toast-precio-detalle">{{ slotProps.message.detail }}</span>
          <Button
            v-if="slotProps.message.data && slotProps.message.data.deshacer"
            label="Deshacer"
            icon="pi pi-undo"
            class="p-button-sm p-button-text mt-2"
            data-testid="deshacer-precio"
            @click="deshacerPrecio(slotProps.message)"
          />
        </div>
      </template>
    </Toast>
    <Dialog
      v-model:visible="deleteProdModal"
      :style="{ width: '450px' }"
      header="Confirmar"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="producto"
          >Estas Seguro que quieres eliminar producto:
          <b>{{ producto.descripcion }}</b> ?</span
        >
      </div>
      <template #footer>
        <Button
          label="No, Cancelar"
          icon="pi pi-times"
          class="p-button-success p-button-lg"
          @click="deleteProdModal = false"
        />
        <Button
          label="Si Eliminar"
          icon="pi pi-check"
          class="p-button-danger p-button-lg"
          @click="deleteProducto"
        />
      </template>
    </Dialog>
    <ProductoImagenes
      :show="verImagenes"
      :producto_id="ProductoImagenes"
      @closeModal="ocultarDialog"
      @actualizarListado="obtenerListadoProductos"
    ></ProductoImagenes>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "@/service/ProductService";
import ProductoCreate from "@/module/productos/ProductoCreate.vue";
import { useAuth } from "@/stores";
import ProductoImagenes from "@/module/productos/ProductoImagenes.vue";

// [2026-10] CAMBIO: constantes de la edición de precio por celda.
// MOTIVO: PERMITIR_PRECIO_VENTA_CERO = false impide guardar P.VENTA en 0 por error de tecleo; poner true para permitirlo.
// REF: docs_trabajo/resultado_celda_frontend.md
const PERMITIR_PRECIO_VENTA_CERO = false;
const CANALES_CELDA = { precio_sugerido: "P.VENTA", pv2: "Yango", pv3: "Pedido Ya", pv4: "Turbo", pv5: "Cortesía" };
const VIDA_DESHACER_MS = 10000;

export default {
  components: { ProductoCreate, ProductoImagenes },
  data() {
    return {
      nuevoProducto: false,
      totalRegistros: 0,
      totalRecords: 0,
      productos: [],
      cargando: true,
      mostrarProductoModal: false,
      producto: {},
      deleteProdModal: false,
      buscar: null,
      lazyParams: {},
      claseEstado: ["status-outofstock", "status-instock"],
      claseEstado2: (data) => {
        if (data.stock_actual <= 0) {
          return "outofstock";
        } else if (data.stock_actual <= 10) {
          return "lowstock";
        } else {
          return "instock";
        }
      },
      verImagenes: false,
      ProductoImagenes: null,
      ultimo_codigo_interno: null,
      parametros_sistema: {},
      mostrar_precio_cif: false,
      stock_decimales: false,
      // [2026-10] CAMBIO: celdas con un guardado en curso («<id>:<campo>» → true). MOTIVO: evitar doble envío.
      guardandoCeldas: {},
    };
  },
  productoService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.productoService = new ProductService();
    this.initBuscar();
  },
  mounted() {
    this.lazyParams = {
      first: 0,
      rows: this.$refs.dtlaboratorios.rows,
      sortField: null,
      sortOrder: null,
      filters: this.buscar,
    };
    this.obtenerListadoProductos();
  },
  methods: {
    getImageUrl(img) {
      if (!img) return null;
      if (img.startsWith("http")) return img;
      if (/\.(jpeg|jpg|gif|png|webp|svg)$/i.test(img)) {
        return process.env.VUE_APP_ROOT_API.replace(/\/api$/, "") + "/storage/" + img;
      }
      return "data:image/png;base64, " + img;
    },
    sinDecimal(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 0,
      }).format(numero);
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero);
    },
    onPage(event) {
      this.lazyParams = event;
      this.obtenerListadoProductos();
    },
    onSort(event) {
      this.lazyParams = event;
    },
    onFilter() {
      this.lazyParams.filters = this.buscar;
      this.obtenerListadoProductos();
    },
    // [2026-10] DEPRECADO/SIN USO 2026-10: onCellEditComplete (versión anterior). Guardaba directo en UNA sucursal
    // (auth.user.sucursal_id || 1), aceptaba también precio_compra y mutaba la fila antes de la respuesta; sus errores
    // mostraban «Error al actualizar» sin el mensaje real. MOTIVO: sustituido por la versión nueva (más abajo), que guarda
    // en todas las sucursales activas con aviso y «Deshacer». Se conserva comentado como referencia.
    // REF: docs_trabajo/resultado_celda_frontend.md
    // onCellEditComplete(event) {
    //   let { data, newValue, field } = event;
    //
    //   switch (field) {
    //     case "precio_compra":
    //     case "precio_sugerido":
    //     case "pv2":
    //     case "pv3":
    //     case "pv4":
    //     case "pv5":
    //       if (this.isPositiveNumber(newValue)) {
    //           data[field] = newValue;
    //           if (field === 'precio_sugerido') {
    //               data.precio_venta = newValue;
    //           }
    //
    //           let current_sucursal_id = this.auth?.user?.sucursal_id || 1;
    //           this.productoService.updateCell(data.id, field, newValue, current_sucursal_id).then(res => {
    //               if(res.success) {
    //                   this.$toast.add({ severity: 'success', summary: 'Éxito', detail: res.message, life: 3000 });
    //               } else {
    //                   this.$toast.add({ severity: 'error', summary: 'Error', detail: res.message, life: 3000 });
    //               }
    //           }).catch(error => {
    //               console.error("Error al actualizar la celda:", error);
    //               this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error al actualizar', life: 3000 });
    //           });
    //       }
    //       else event.preventDefault();
    //       break;
    //
    //     default:
    //       if (String(newValue).trim().length > 0) data[field] = newValue;
    //       else event.preventDefault();
    //       break;
    //   }
    // },
    // [2026-10] CAMBIO: la celda se guarda al terminar la edición (Enter, Tab o clic fuera), siempre en todas las sucursales
    // activas, sin diálogo. MOTIVO: cambio rápido de precios. El editor trabaja sobre una copia de la fila (BodyCell.vue de
    // PrimeVue 3.53.1: editingRowData), por eso `event.data` conserva el valor anterior hasta que el servidor responde.
    // REF: docs_trabajo/resultado_celda_frontend.md
    onCellEditComplete(event) {
      const { data, field, newData } = event;
      if (!(field in CANALES_CELDA)) return;
      const celda = this.celdaDe(event);
      const clave = data.id + ":" + field;
      if (this.guardandoCeldas[clave]) return; // ya hay un guardado en curso para esta celda
      if (!newData || !newData._celdaTocada) { // no se escribió nada (clic y salir)
        if (event.type === "enter") this.enfocarCelda(celda);
        return;
      }
      const anterior = Number(this.valorMostrado(data, field));
      const nuevo = this.aPrecio(newData[field]);
      if (nuevo === null) {
        this.avisarPrecio("warn", "Precio no válido", "Escriba un número mayor o igual a 0.");
        this.enfocarCelda(celda);
        return;
      }
      if (nuevo === Math.round(anterior * 100) / 100) {
        this.enfocarCelda(celda);
        return;
      }
      if (field === "precio_sugerido" && nuevo === 0 && !PERMITIR_PRECIO_VENTA_CERO) {
        this.avisarPrecio("warn", "Precio no válido", "El precio de venta no puede ser 0");
        this.enfocarCelda(celda);
        return;
      }
      this.guardarPrecio(data, field, anterior, nuevo, celda);
    },
    // [2026-10] CAMBIO: Escape cancela la edición (PrimeVue ya descarta la copia); solo se devuelve el foco a la tabla.
    onCellEditCancel(event) {
      this.enfocarCelda(this.celdaDe(event));
    },
    celdaDe(event) {
      const t = event && event.originalEvent && event.originalEvent.target;
      return t && t.closest ? t.closest("td") : null;
    },
    // Valor que la tabla muestra: en P.VENTA es precio_venta si es > 0 y si no precio_sugerido (igual que la plantilla).
    valorMostrado(data, field) {
      if (field === "precio_sugerido") return data.precio_venta > 0 ? data.precio_venta : data.precio_sugerido;
      return data[field];
    },
    valorEditor(data, field) {
      return data._celdaTocada ? data[field] : Number(this.valorMostrado(data, field) ?? 0);
    },
    editarCelda(data, field, valor) {
      data[field] = valor;
      data._celdaTocada = true;
    },
    // Devuelve el precio con 2 decimales, o null si está vacío, no es numérico o es negativo.
    aPrecio(valor) {
      if (valor === null || valor === undefined) return null;
      let n;
      if (typeof valor === "number") n = valor;
      else {
        const texto = String(valor).trim().replace(",", ".");
        if (!/^\d+(\.\d+)?$/.test(texto)) return null;
        n = Number(texto);
      }
      if (!Number.isFinite(n) || n < 0) return null;
      return Math.round(n * 100) / 100;
    },
    avisarPrecio(severity, summary, detail, data = null, life = 4000) {
      this.$toast.add({ group: "precio-celda", severity, summary, detail, life, data });
    },
    textoCambio(producto, field, anterior, nuevo, n) {
      return (
        producto.descripcion + " · " + CANALES_CELDA[field] + ": " + this.convertirNumeroGermanicFormat(anterior) +
        " → " + this.convertirNumeroGermanicFormat(nuevo) + " en " + n + " sucursal(es)"
      );
    },
    aplicarEnFila(fila, field, valor) {
      fila[field] = valor;
      if (field === "precio_sugerido") fila.precio_venta = valor; // como hacía el handler viejo
    },
    // Mensaje real del error: string (fetchWrapper), objeto { message, errors } del servicio o Error.
    mensajeError(e) {
      if (typeof e === "string") return e;
      const primero = e && e.errors ? Object.values(e.errors).flat()[0] : null;
      return primero || (e && e.message) || "No se pudo guardar el precio.";
    },
    enviarPrecio(id, field, valor) {
      return this.productoService.updateCell(id, field, valor, null, { aplicar_todas_sucursales: true });
    },
    guardarPrecio(fila, field, anterior, nuevo, celda) {
      const clave = fila.id + ":" + field;
      this.guardandoCeldas = { ...this.guardandoCeldas, [clave]: true };
      this.enviarPrecio(fila.id, field, nuevo)
        .then((res) => {
          const n = Number(res.filas_cambiadas ?? 0);
          this.aplicarEnFila(fila, field, nuevo);
          if (n === 0) {
            this.avisarPrecio("info", "Sin cambios", "Sin cambios: el valor ya era ese");
          } else {
            this.avisarPrecio("success", "Precio actualizado", this.textoCambio(fila, field, anterior, nuevo, n), {
              deshacer: { id: fila.id, field, anterior, nuevo, descripcion: fila.descripcion },
            }, VIDA_DESHACER_MS);
          }
        })
        .catch((e) => {
          this.avisarPrecio("error", "No se guardó el precio", this.mensajeError(e), null, 6000); // un solo toast; la fila no cambió
        })
        .finally(() => {
          const copia = { ...this.guardandoCeldas };
          delete copia[clave];
          this.guardandoCeldas = copia;
          this.enfocarCelda(celda);
        });
    },
    // [2026-10] CAMBIO: «Deshacer» vuelve a llamar a update-cell con el valor anterior en todas las sucursales activas.
    deshacerPrecio(message) {
      const d = message && message.data && message.data.deshacer;
      if (!d) return;
      this.$toast.remove(message);
      const clave = d.id + ":" + d.field;
      if (this.guardandoCeldas[clave]) return;
      this.guardandoCeldas = { ...this.guardandoCeldas, [clave]: true };
      this.enviarPrecio(d.id, d.field, d.anterior)
        .then((res) => {
          const n = Number(res.filas_cambiadas ?? 0);
          const fila = this.productos.find((p) => p.id === d.id);
          if (fila) this.aplicarEnFila(fila, d.field, d.anterior);
          this.avisarPrecio("success", "Cambio deshecho",
            n === 0 ? "Sin cambios: el valor ya era ese"
              : this.textoCambio(d, d.field, d.nuevo, d.anterior, n));
        })
        .catch((e) => {
          this.avisarPrecio("error", "No se pudo deshacer", this.mensajeError(e), null, 6000);
        })
        .finally(() => {
          const copia = { ...this.guardandoCeldas };
          delete copia[clave];
          this.guardandoCeldas = copia;
        });
    },
    // [2026-10] CAMBIO: tras guardar o cancelar el foco vuelve a la celda (tabla) para seguir editando; no se roba el foco
    // si el usuario ya puso el cursor en otro control.
    enfocarCelda(celda) {
      this.$nextTick(() => {
        const el = celda && celda.isConnected ? celda : this.$refs.dtlaboratorios && this.$refs.dtlaboratorios.$el;
        if (!el) return;
        const activo = document.activeElement;
        if (activo && activo !== document.body && activo !== el && !el.contains(activo)) return;
        if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
        el.focus({ preventScroll: true });
      });
    },
    isPositiveNumber(val) {
      if (val === null || val === "") return true;
      let str = String(val).trim();
      if (!str) return false;
      let n = Number(str);
      return n !== Infinity && !isNaN(n) && n >= 0;
    },
    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions;
      return [
        {
          label: "Editar",
          disabled: "Producto Editar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-pencil",
          command: () => {
            this.editarProducto(datos);
          },
        },
        {
          label: "Ver Detalle",
          disabled:
            "Producto Ver Detalle" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-eye",
          command: () => {
            this.verDetalle(datos);
          },
        },
        {
          label: "Ver Imagenes",
          visible: "Producto VerImagen" in permisosUsuarioAuth ? true : false,
          icon: "pi pi-image",
          command: () => {
            this.mostrar_imagenes(datos.id);
          },
        },
        {
          label: "Eliminar",
          disabled: "Producto Eliminar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-trash",
          command: () => {
            this.confirmDeleteProducto(datos);
          },
        },
      ];
    },
    ocultarDialog() {
      this.verImagenes = false;
    },
    mostrar_imagenes(producto_id) {
      this.ProductoImagenes = producto_id;
      this.verImagenes = true;
    },
    openModal() {
      this.producto = {
        estado: { label: "Activo", value: 1 },
        stock_minimo: 0,
        stock_maximo: 0,
        precio_sugerido: 0,
        pv2: 0,
        pv3: 0,
        pv4: 0,
        pv5: 0,
        tipo_catalogo: 1,
        codigo_interno: this.ultimo_codigo_interno ?? "",
      };
      this.mostrarProductoModal = true;
    },
    cerrarModal() {
      this.mostrarProductoModal = false;
      this.producto = {};
    },
    obtenerListadoProductos() {
      this.cargando = true;
      setTimeout(() => {
        this.productoService
          .getAllProductos({ dt_params: JSON.stringify(this.lazyParams) })
          .then((data) => {
            this.parametros_sistema = data.parametros_sistema || {};

            this.parametros_sistema.some((parametro) => {
              if (parametro.nombre == "mostrar_cif" && parametro.estado == 1) {
                this.mostrar_precio_cif = true;
              }
              if (
                parametro.nombre == "stock_decimales" &&
                parametro.estado == 1
              ) {
                this.stock_decimales = true;
              }
            });

            this.totalRecords = data.productos.total || 0;
            this.productos = data.productos.data || [];
            if (this.productos.length > 0) {
              this.ultimo_codigo_interno =
                data.productos.data[0].codigo_interno &&
                !isNaN(data.productos.data[0].codigo_interno)
                  ? parseInt(data.productos.data[0].codigo_interno) + 1
                  : data.productos.data[0].codigo_interno ?? "";
            }
            this.cargando = false;
            this.productos.forEach((producto) => {
              producto.created_at = new Date(producto.created_at);
              producto.updated_at = new Date(producto.updated_at);
              producto.estado = {
                label: this.textoEstado(producto.estado),
                value: producto.estado,
              };
            });
          });
      }, Math.random() * 1000 + 250);
    },
    textoEstado(estado) {
      return estado == 1 ? "Activo" : "Inactivo";
    },
    editarProducto(info_producto) {
      this.producto = { ...info_producto };
      this.producto.stock_minimo = parseInt(this.producto.stock_minimo || 0);
      this.producto.stock_maximo = parseInt(this.producto.stock_maximo || 0);
      this.producto.precio_sugerido = parseFloat(
        this.producto.precio_sugerido || 0
      );
      this.producto.precio_compra = parseFloat(
        this.producto.precio_compra || 0
      );
      if (this.stock_decimales) {
        this.producto.stock_actual = parseFloat(
          this.producto.stock_actual || 0
        );
      } else {
        this.producto.stock_actual = parseInt(this.producto.stock_actual || 0);
      }
      this.producto.tipo_catalogo = parseInt(this.producto.tipo_catalogo || 1);

      // --- CORRECCIÓN APLICADA AQUÍ ---
      // Si existe información en la relación stock, extraemos sucursal_id y los demás campos asociados
      if (this.producto.stock && this.producto.stock.length > 0) {
        this.producto.precio_cif = parseFloat(this.producto.stock[0].precio_cif || 0);
        this.comision_medico = parseFloat(this.producto.stock[0].comision_medico || 0);
        this.producto.pv2 = parseFloat(this.producto.stock[0].pv2 || 0);
        this.producto.pv3 = parseFloat(this.producto.stock[0].pv3 || 0);
        this.producto.pv4 = parseFloat(this.producto.stock[0].pv4 || 0);
        this.producto.pv5 = parseFloat(this.producto.stock[0].pv5 || 0);

        // Extraer la sucursal de manera tolerante a diferentes formatos
        this.producto.sucursal_id =
          this.producto.stock[0].sucursal_id ??
          this.producto.stock[0].id_sucursal ??
          this.producto.sucursal_id;
      } else {
        this.producto.precio_cif = 0;
        this.comision_medico = 0;
        this.producto.pv2 = parseFloat(this.producto.pv2 || 0);
        this.producto.pv3 = parseFloat(this.producto.pv3 || 0);
        this.producto.pv4 = parseFloat(this.producto.pv4 || 0);
        this.producto.pv5 = parseFloat(this.producto.pv5 || 0);
      }

      this.mostrarProductoModal = true;
    },
    verDetalle(producto) {
      this.$router.push(`/producto/${producto.id}/detalle`);
    },
    confirmDeleteProducto(producto) {
      this.producto = { ...producto };
      this.deleteProdModal = true;
    },
    deleteProducto() {
      this.productoService.deleteProducto(this.producto).then((response) => {
        if (response.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Exito",
            detail: response.mensaje,
            life: 3000,
          });
          this.productos = this.productos.filter(
            (val) => val.id !== this.producto.id
          );
          this.deleteProdModal = false;
          this.producto = {};
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.mensaje,
            life: 3000,
          });
          this.deleteProdModal = false;
        }
      });
    },
    initBuscar() {
      this.buscar = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        codigo_interno: { value: null, matchMode: FilterMatchMode.EQUALS },
        codigo_barra: { value: null, matchMode: FilterMatchMode.EQUALS },
        descripcion: { value: null, matchMode: FilterMatchMode.CONTAINS },
        "fabricas.nombre": { value: null, matchMode: FilterMatchMode.CONTAINS },
        "grupo.nombre": { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: red;
}
.outofstock {
  font-weight: 700;
  color: #000000;
  background-color: #ff5252;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.lowstock {
  font-weight: 700;
  color: #000000;
  background-color: #fbc02d;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.instock {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 0 0.5em;
  border-radius: 0.5em;
}
</style>